import {gsap, Observer, ScrollTrigger} from "../LibrariesImport";
import {GlobalVariables} from "../GlobalVariables";

export default class Header {

	static init() {
		this.header = document.querySelector(".header-main");
		if (this.header) {
			this.navMain = this.header.querySelector(".nav-main");
			this.headerClass = this.header.className;
			this.toggleHeader();
			this.initNav();
			this.resize();
			this.onBodyScroll();
		}

		GlobalVariables.resizeCallbacks.push(this);
	}

	static headerAddSpacing(){
		// let headerHeight = this.header.offsetHeight;
		let firstSection = document.querySelector('.page-container');
		let spacer = firstSection.querySelector('.header-spacer');
		if( !spacer ){
			spacer = document.createElement("div");
			spacer.classList.add('header-spacer');
			firstSection.insertBefore(spacer, firstSection.firstChild);
		}
		spacer.style.height = this.header.offsetHeight+"px";
	}

	static initNavLang(){

		const mobileLang = document.querySelector(".nav-lang");
		if(mobileLang && GlobalVariables.isMobile){
			mobileLang.addEventListener("click", (e) => {
				document.body.classList.toggle('nav-lang-open', !document.body.classList.contains('nav-lang-open'));
			});
		}

	}

	static openMobileMenu(){

		const openMobileMenu = document.querySelector(".nav-main-toggle");
		openMobileMenu.addEventListener("click", () => {
			document.body.classList.toggle("nav-main-open");
			GlobalVariables.smoother.paused( document.body.classList.contains("nav-main-open") );
		});

	}

	static toggleHeader() {
		Observer.create({
			type: "scroll",
			tolerance: 30,
			dragMinimum: 30,
			onStop: () => {
				if (window.scrollY < 100) {
					this.header.classList.add("is-on-top");
					this.header.className = this.headerClass;
				} else {
					this.header.classList.remove("is-on-top");
				}
			},
			onStopDelay: 0,
			onUp: () => {
				this.showHeader();
			},
			onDown: () => {
				this.hideHeader();
			},
		});

		if (window.innerWidth > 991) {
			setTimeout(() => {
				if (window.scrollY > 100) {
					this.hideHeader();
				}
			}, 0);
		}
	}

	static onBodyScroll(){
		Observer.create({
			type: "scroll,wheel",
			tolerance: 30,
			dragMinimum: 30,
			onChange: () => {
				document.body.classList.remove('nav-lang-open');
			}
		});
	}

	static hideHeader() {
		this.header.className = this.headerClass + " hide ";
	}

	static showHeader() {
		this.header.classList.remove("hide");
		if (this.header.classList.contains('header-main-full')) {
			this.removeClassByPrefix(this.header, 'section');
			this.header.classList.add('section');
			this.header.classList.add( this.header.dataset.sectionColor );
		}
	}

	static initNav() {
		this.initNavLang();
		this.openMobileMenu();
	}

	static openSubNavBurger(element){

		element.preventDefault();
		let item = element.target.closest('.menu-item--lev1') || element.target;
		let subNav = item.querySelector('.lev2');

		if (item.classList.contains("subnav-open")) {
			item.classList.remove("subnav-open");
			gsap.to(subNav, {
				height: 0,
				duration: 0.3
			});
		} else {
			item.classList.add("subnav-open");
			gsap.to(subNav, {
				height: subNav.dataset.height,
				duration: 0.3
			});
		}

	}

	static removeNavMainSectionClass(){

		if( !this.header.classList.contains('header-main-burger') && window.innerWidth > 991 ){
			this.removeClassByPrefix(this.navMain, 'section');
		}else{
			this.navMain.classList.add("section");
			this.navMain.classList.add(this.header.dataset.sectionColor);
		}

	}

	static removeClassByPrefix(node, prefix) {
		const regx = new RegExp('\\b' + prefix + '[^ ]*[ ]?\\b', 'g');
		node.className = node.className.replace(regx, '');
		return node;
	}

	static resize(){

		this.removeNavMainSectionClass();

		if( document.body.classList.contains('page-template-template-contact') ||
			document.body.classList.contains('post-type-archive-jobs') ||
			document.body.classList.contains('single-jobs') ||
			document.body.classList.contains('search') ){
				this.headerAddSpacing();
		}

		if (window.innerWidth > 991) {
			document.body.classList.remove("nav-main-open");
			GlobalVariables.smoother.paused( false );
		}

	}
}
